<div class="full-screen-wizard">
  <button mat-icon-button style="position: absolute; right: 2px; top: 2px; z-index:99999;" (click)="onClose()"><mat-icon>close</mat-icon></button>
  <div mat-dialog-title class="wizard-header">
    <mat-progress-bar mode="determinate" [value]="progressValue" [color]="currentStep === 3 ? 'accent' : 'primary'" class="wizard-progress"></mat-progress-bar>
    <div class="header-main">
      <div class="header-content">
        <mat-icon class="horizinns-green">assignment</mat-icon>
        <div class="title-group">
          <span class="main-title">Sales Consultant Listing Form</span>
          <span class="step-label">Step {{currentStep}} of 4: {{stepName}}</span>
        </div>
      </div>
    </div>
  </div>

  <mat-dialog-content class="wizard-body">
    @if (isLoading()) {
      <div class="loading-overlay">
        <app-loader></app-loader>
        <p>Generating your signed PDF...</p>
      </div>
    }

    <div class="step-container" [class.hidden]="isLoading()">
      @if (currentStep === 1) { 
        <div style="display:flex; width:100%; height:100%; justify-content: center; align-content: center; padding-top: 3em; padding-bottom: 5em;">
          <mat-card class="horizinns-card more-blur white-blur mw-80">
            <mat-card-content>
              <app-instructions></app-instructions> 
            </mat-card-content>
          </mat-card>
        </div>
      }
      @if (currentStep === 2) { 
        <div class="sales-consultant-listing-form-container">
            <div class="column">
                <mat-card class="horizinns-card even-more-blur white-blur center document-preview-card">
                    <mat-card-content>
                        @defer (on timer(0s)) {
                          <app-document-preview [pdfSrc]="pdfUrlForPreview"></app-document-preview> 
                        }
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="column">
                <div class="sales-consultant-listing-form">
                    <mat-card class="horizinns-card more-blur white-blur">
                        <mat-card-content>
                            <app-listing-form (formValidity)="handleValidity($event)" (formDataChange)="handleFormUpdate($event)"></app-listing-form>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>
      }
      @if (currentStep === 3) {
        <app-listing-form-review [pdfUrlForPreview]="pdfUrlForPreview"></app-listing-form-review>
      }
      @if (currentStep === 4) { 
        <div style="display:flex; width:100%; height:100%; justify-content: center; align-content: center; padding-top: 3em;">
          <mat-card class="horizinns-card more-blur white-blur mw-60 ">
            <mat-card-content>
              <app-listing-form-success></app-listing-form-success> 
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>
  </mat-dialog-content>

  <div mat-dialog-actions class="wizard-footer">
    <button mat-flat-button class="metallic-text-btn" (click)="onBack()" *ngIf="currentStep > 1 && currentStep < 4 && !isLoading()">Back</button>
    <span class="spacer"></span>
    <button mat-flat-button class="metallic-text-btn-blue" (click)="onNext()" [disabled]="isLoading() || (currentStep === 2 && isCurrentStepValid() === false)">
      {{ currentStep === 3 ? 'Finish' : currentStep === 4 ? 'Close' :'Next' }}
    </button>
  </div>
</div>
<div style="display: none;">{{ isCurrentStepValid() }}</div>

<!-- <h2 mat-dialog-title>Fill Document</h2>

<mat-dialog-content>
  @switch (currentState()) {
    @case ('INSTRUCTIONS') {
      <app-instructions (start)="goToForm()" />
    }
    @case ('FILLING_FORM') {
      <div class="split-view">
        <app-document-preview [pdfSrc]="pdfUrlForPreview"></app-document-preview>
        <app-form (submit)="generatePdf($event)" />
      </div>
    }
    @case ('PREVIEW_GENERATED') {
      <app-document-preview [pdfSrc]="pdfUrlForApplied"></app-document-preview>
      <button (click)="goToForm()">Edit Values</button>
      <button (click)="finalize()">Submit Final</button>
    }
  }
</mat-dialog-content> -->